function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 33C19.626 33 17.3409 32.0196 15.6498 30.2608C13.9574 28.5007 13 26.1054 13 23.6C13 21.5824 13.7483 19.7222 14.9073 17.9195C16.005 16.2119 17.4239 14.6242 18.8424 13.037C18.9324 12.9363 19.0224 12.8356 19.1123 12.7349L20.5083 11.1717C21.3034 10.2813 22.6966 10.2813 23.4917 11.1717L24.8876 12.7348C24.8877 12.7349 24.8878 12.735 24.8879 12.7351C24.9786 12.8368 25.0694 12.9384 25.1602 13.0401C26.5779 14.6269 27.9957 16.2139 29.0927 17.9204C30.2517 19.7232 31 21.5831 31 23.6C31 26.1054 30.0426 28.5007 28.3502 30.2608C26.6591 32.0196 24.374 33 22 33Z",
  stroke: "currentColor",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19 25C19 25 19.5 26.5 21 27",
  stroke: "currentColor",
  strokeWidth: 3,
  strokeLinecap: "square"
});

var SvgAddWatermark = function SvgAddWatermark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddWatermark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-watermark.9fa675fa.svg";
export { ForwardRef as ReactComponent };